module.exports = __webpack_public_path__ + "1ab43da1e0f881b0e074eca4405ca38b.png";